import { NextcloudActionType } from '../../actions/nextcloud/actionTypes';
import { produce } from 'immer';
import { AnyAction } from 'redux';
import { Circle } from '../../../services/microsoft/msGraphApi';
import { Share } from '@sendent/nextcloud-api';

const initialState = {
    circles: [] as Circle[] | null,
    shares: [] as Share[] | null,
};

export function nextcloudReducer(state = initialState, action: AnyAction) {
    switch (action.type) {
        case NextcloudActionType.SetCircles:
            return produce(state, (draft) => {
                draft.circles = action.payload.circles;
            });
        case NextcloudActionType.SetShares:
            return produce(state, (draft) => {
                draft.shares = action.payload.shares;
            });
        default:
            return state;
    }
}
